<template>
    <div>
        <div class="container" style="width:100%;">
            <div style="font-size:20px;"><i class="el-icon-s-unfold "></i><span style="margin-left:5px;">服务分析</span></div>
            <div style="display:flex;margin-top:-40px;">
                <div style="width:200px;display:flex;flex-direction:column;justify-content:center;">
                   
                        <el-card shadow="hover" :body-style="{ padding: '0px' }" style="width: 400px;">
                            <div class="grid-content grid-con-1">
                                <!-- <i class="el-icon-user-solid grid-con-icon"></i> -->
                                <el-image
                                        style="width: 100px; height: 100px"
                                        :src="require('@/assets/ana1.png')"
                                        :fit="'scale-down'"></el-image>
                                <div class="grid-cont-right">
                                    <div class="grid-num">356</div>
                                    <div>客户沟通总次数</div>
                                </div>
                            </div>
                        </el-card>
                        <el-card shadow="hover" :body-style="{ padding: '0px' }" style="width: 400px;margin-top:10px;">
                            <div class="grid-content grid-con-1">
                                <!-- <i class="el-icon-user-solid grid-con-icon"></i> -->
                                <el-image
                                        style="width: 100px; height: 100px"
                                        :src="require('@/assets/ana2.png')"
                                        :fit="'scale-down'"></el-image>
                                <div class="grid-cont-right">
                                    <div class="grid-num">18</div>
                                    <div>每客户平均沟通次数</div>
                                </div>
                            </div>
                        </el-card>

                        <el-card shadow="hover" :body-style="{ padding: '0px' }" style="width: 400px;margin-top:10px;">
                            <div class="grid-content grid-con-1">
                                <!-- <i class="el-icon-user-solid grid-con-icon"></i> -->
                                <el-image
                                        style="width: 100px; height: 100px"
                                        :src="require('@/assets/ana3.png')"
                                        :fit="'scale-down'"></el-image>
                                <div class="grid-cont-right">
                                    <div class="grid-num">573</div>
                                    <div>通话总时长(秒)</div>
                                </div>
                            </div>
                        </el-card>
                        <el-card shadow="hover" :body-style="{ padding: '0px' }" style="width: 400px;margin-top:10px;">
                            <div class="grid-content grid-con-1">
                                <!-- <i class="el-icon-user-solid grid-con-icon"></i> -->
                                <el-image
                                        style="width: 100px; height: 100px"
                                        :src="require('@/assets/ana4.png')"
                                        :fit="'scale-down'"></el-image>
                                <div class="grid-cont-right">
                                    <div class="grid-num">3.6</div>
                                    <div>平均通话时长(秒)</div>
                                </div>
                            </div>
                        </el-card>
                   
                </div>
                <div style="width:100%;display:flex;justify-content: center;">
                    <div id="analysis_Index" style="width:550px;height: 550px;margin-top:0px;margin-left:-50px;"></div>
                </div>
            </div>

            <el-row style="margin-top:-100px;">
                <el-col :span="12">
                    <div id="analisysCate1" style="width:600px;height: 400px;padding-top:10px;"></div>
                </el-col>
                <el-col :span="12">
                    <div id="analisysCate2" style="width:600px;height: 400px;padding-top:10px;"></div>
                </el-col>
            </el-row>
            <el-row>
                <el-table 
                :data="analisysCall" 
                border :header-cell-style="{background:'#eef1f6',color:'#606266'}" height="800"
                        style="width: 80%;margin-top: 10px;" ref="Table" >
                <el-table-column prop="clientname" align="center" sortable  label="终端客户/经销商" >
                </el-table-column>
                <el-table-column prop="clienttype" align="center" sortable width="121" label="类型" ></el-table-column>
                <el-table-column prop="无法联系" align="center" sortable  label="无法联系(次数)" ></el-table-column>
                <el-table-column prop="取得联系" align="center" sortable  label="取得联系(次数)" ></el-table-column>
                </el-table>
            </el-row>

            
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
		showAnalysis_Index,
} from "@/views/ZC/utils";
import {
        indexCate,
} from "@/views/Index/utils";

export default {
    name: 'baseform',
    components: {

      },
    computed: {
        ...mapGetters(['analisysCate1','analisysCate2','analisysCall'])
    },
    data() {
        return {

        };
    },

    async mounted() {
        showAnalysis_Index("analysis_Index");
        await this.$store.dispatch('zc/ZC_Index',{}).then(()=>{
            if (document.readyState === "complete") {
                indexCate('analisysCate1',this.analisysCate1);
                indexCate('analisysCate2',this.analisysCate2);
            }                
        })

    },


    methods: {
        
    }
};
</script>

<style scoped>
.grid-content {
    display: flex;
    align-items: center;
    height: 100px;
}
.grid-con-icon {
    font-size: 50px;
    width: 100px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    /* color: #fff; */
}

.grid-cont-right {
    flex: 1;
    text-align: center;
    font-size: 14px;
    color: #999;
}
.grid-num {
    font-size: 30px;
    font-weight: bold;
}
.grid-con-1 .grid-num {
    color: #2F5597;
}
</style>